
import {Vue, Component, Emit} from 'vue-property-decorator';
import PageTitle from '@/components/PageTitle.vue';
import * as ServiceService from '@/services/merchantSpace/ServiceService';
import RetailScalePoints from '@/components/Dialogs/RetailScalePoints.vue';
import ScalePointDatabase from '@/views/account/ScalePointsDatatable.vue'
import { PlatformService } from '@/services/merchantSpace/types';

const moment = require('moment');

@Component({
  components: {
    PageTitle,
    RetailScalePoints,
    ScalePointDatabase,
  },
})

export default class ScalePoints extends Vue {
  uuidPlatform!: string;

  services: PlatformService[] = [];

  scalePoints: any[] = [];

  frequency = '';

  actionCreditSelected: any = null;

  actionsToDisplay: any[] = [];

  async mounted() {
    await this.createData();
  }

  filterActionCreditList(actionCreditList) {
    return actionCreditList
      .filter((actionCredit) => !actionCredit.isRevoked && actionCredit.actionCategory.id !== 8 && actionCredit.value !== 0)
      .map((actionCredit) => ({
        ...actionCredit,
        criteria: actionCredit.criteria.filter((criteria) => !criteria.isRevoked),
      }));
  }



  async createData() {
    this.services = await ServiceService.getPlatformServices();
    this.services.sort((a, b) => a.rank - b.rank);
    const actionCredits = this.services.flatMap(
      (service) => this.filterActionCreditList(service.actionCreditList || [])
    );

    const uniqueActionCredits = actionCredits.reduce((acc, actionCredit) => {
      const key = `${actionCredit.label}-${actionCredit.value}-${actionCredit.limit}-${actionCredit.frequency.id}`;
      if (!acc.has(key)) {
        acc.set(key, actionCredit);
      }
      return acc;
    }, new Map());

    this.actionsToDisplay = [...uniqueActionCredits.values()].sort((a, b) => {
      if (a.position === null) {
        return 1;
      }
      if (b.position === null) {
        return -1;
      }
      return a.position - b.position;
    });
  }

  textualization(actionCredit) {
    const {
      limit,
      value,
      frequency: {id: frequencyId},
      targetAudience: {id: targetAudienceId},
      actionCategory: {id: actionCategoryId, labelFr: actionCategoryLabel},
      ...others
    } = actionCredit;

    let text = '';
    let textLimit = '';
    let textFrequency = '';
    let textTargetAudience = '';
    let textPoint = '';

    if (targetAudienceId === 2) {
      textTargetAudience = ' pro';
    } else {
      textTargetAudience = '';
    }

    if (value < 2) {
      textPoint = ' point';
    } else {
      textPoint = 'points';
    }

    const textStart = `Gagnez ${value} ${textPoint}${textTargetAudience}`;

    switch (frequencyId) {
      case 1:
        textFrequency = '';
        break;
      case 2:
        textFrequency = ' par jour';
        break;
      case 3:
        textFrequency = ' par semaine';
        break;
      case 4:
        textFrequency = ' par mois';
        break;
      case 5:
        textFrequency = ' par an';
        break;
      default:
        textFrequency = '';
    }

    if (limit === 0 || (limit === 1 && frequencyId === 1)) {
      textLimit = ``;
    } else if (limit > 1 && frequencyId === 1) {
      textLimit = `, dans la limite de ${limit} fois`;
    } else if (limit === 1 && frequencyId !== 1) {
      textLimit = `, dans la limite de 1 fois${textFrequency}`;
    } else {
      textLimit = `, dans la limite de ${limit} fois${textFrequency}`;
    }

    switch (actionCategoryId) {
      case 1:
        text = `${textStart} pour la validation de votre email${textLimit}.`;
        break;
      case 2:
        text = `${textStart} pour votre ${actionCategoryLabel}${textLimit}.`;
        break;
      case 3:
        text = `${textStart} par ${actionCategoryLabel}${textLimit}.`;
        break;
      case 4:
        text = `${textStart} par ${actionCategoryLabel}${textLimit}.`;
        break;
      case 5:
        text = `${textStart} pour l'${actionCategoryLabel} standard${textLimit}.`;
        break;
      case 6:
        text = `${textStart} pour la ${actionCategoryLabel}${textLimit}.`;
        break;
      case 7:
        text = `${textStart} pour votre inscription avec un code parrainage${textLimit}.`;
        break;
      default:
        text = `${textStart} par ${actionCategoryLabel}${textLimit}.`;
    }
    return text;
  }

  formatedDate(date): string {
    return moment(date).format('DD/MM/YYYY');
  }

  formatedHour(hour): string {
    const tableau = hour.split(':');
    const popedTab = tableau.pop();
    const hours = tableau.join('h');
    return hours;
  }

  formatedDays(days: number[]) {
    const matchDay = {
      0: 'lundi',
      1: 'mardi',
      2: 'mercredi',
      3: 'jeudi',
      4: 'vendredi',
      5: 'samedi',
      6: 'dimanche',
    };

    return days.map((day) => matchDay[day]).join(', ');
  }
}
